import { render, staticRenderFns } from "./SellerInformation.vue?vue&type=template&id=5816d71b"
import script from "./SellerInformation.vue?vue&type=script&lang=js"
export * from "./SellerInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports